<div *ngFor="let track of tracking" class="row-container">
    <div class="shipping-info">
        <div class="shipping-info-header">
            <app-date-format [date]="track.eventDatetime"></app-date-format>
        </div>
        <div class="shipping-info-header-text">
            {{ track.eventMessage }}
        </div>
    </div>
</div>